export const isEmail = (value: string): boolean => {
	// eslint-disable-next-line
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return !!value && re.test(value)
}
export const isPhone = (value: string): boolean => {
	const r = RegExp('^0[4,2,3,7,8]');
	const nv = (value || '').replace(/\s/g, '').replace(/-/g, '');
	return (
		!!nv && 
		nv.length == 10 && 
		r.test(nv)
	);
}